var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVectorAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 4C6 4.83934 5.48296 5.55793 4.75 5.85462V7C4.75 9.34721 6.65279 11.25 9 11.25V11C9 9.89543 9.89543 9 11 9H13C14.1046 9 15 9.89543 15 11V11.25C18.1756 11.25 20.75 13.8244 20.75 17V18.1454C21.483 18.4421 22 19.1607 22 20C22 21.1046 21.1046 22 20 22C18.8954 22 18 21.1046 18 20C18 19.1607 18.517 18.4421 19.25 18.1454V17C19.25 14.6528 17.3472 12.75 15 12.75V13C15 14.1046 14.1046 15 13 15H11C9.89543 15 9 14.1046 9 13V12.75C5.82436 12.75 3.25 10.1756 3.25 7V5.85462C2.51704 5.55793 2 4.83934 2 4C2 2.89543 2.89543 2 4 2C5.10457 2 6 2.89543 6 4Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVectorAlt);
export default __webpack_public_path__ + "static/media/vector-alt.e3e331baabebafb6a07c004b1fc5608f.svg";
export { ForwardRef as ReactComponent };